import React, { useState, useEffect } from "react";
import "./styles/education.css";
import Eductionservice from "../../service/Eductionservice";

const Education = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const response = await Eductionservice.getAllInfo();
      const newData = response.docs.map((doc) => doc.data()); // Extract data from each document
      setData(newData);
     
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <div className="education-container">
      <h2 className="education-title">Education</h2>
      <div className="education-list">
        {data.map((edu, index) => (
          <div className="education-item" key={index}>
            <div className="education-institution">{edu.institution}</div>
            <div className="education-degree">{edu.degree}</div>
            <div className="education-year">{edu.year}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Education;
